module.exports = __webpack_public_path__ + "static/Gilroy-Heavy-791d301cd017ac3c1a5b4098ed9f39ce.woff";